<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="companiesUser"
      :search="search"
      sort-by="company"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>PERMISSÃO EMPRESAS - USUÁRIO</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-toolbar-title v-if="user.id"
            >{{ user.id }} - {{ user.name.toUpperCase() }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field> -->
          <v-spacer></v-spacer>
          <v-btn
            color="success darken-1"
            class="mr-4"
            @click="openDialogCompany()"
          >
            <v-icon left>mdi-plus</v-icon> Adicionar Empresa
          </v-btn>
          <v-btn outlined color="grey darken-3" @click="goToBackList()">
            <v-icon left>mdi-chevron-left</v-icon> Voltar
          </v-btn>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-toolbar color="red lighten-1" dark class="text-h5"
                >Atenção</v-toolbar
              >
              <v-card-title class="text-h6">
                Tem certeza que deseja Deletar?
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete()"
                  >Fechar</v-btn
                >
                <v-btn color="red darken-1" dark @click="deleteItemConfirm()">
                  <v-icon dark>mdi-delete</v-icon>
                  Deletar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.status="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ getLabel(item.status) }}
        </v-chip>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.company="{ item }">
        {{ item.company.code }} - {{ item.company.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.type="{ item }">
        <v-chip label :color="getColorType(item.company.type)" dark>
          {{ getLabelType(item.company.type) }}
        </v-chip>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <!-- <v-tooltip top color="blue darken-1"> -->
        <!-- eslint-disable-next-line -->
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="blue darken-1"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip> -->
        <v-tooltip top color="error">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red darken-1"
              @click="deleteItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Deletar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize()"> Recarregar </v-btn>
      </template>
    </v-data-table>
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogAddCompany"
          scrollable
          persistent
          max-width="800px"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Vincular Usuário na Empresa</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <alert
                  :visible="!!alertDialogCompany"
                  dark
                  type="error"
                  :message="alertDialogCompany"
                  :clickClose="() => (alertDialogCompany = '')"
                />
                <!-- <v-row>
                  <v-col>
                    <v-checkbox
                      v-model="checkboxAdmin"
                      label="Permissões da Franqueadora"
                    ></v-checkbox>
                  </v-col>
                </v-row> -->
                <v-row v-if="checkboxAdmin === false">
                  <v-col cols="12" md="6">
                    <v-select
                      :items="typesCompany"
                      v-model="typeCompany"
                      label="Tipo Empresa:"
                      required
                      @change="handleTypeCompany()"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      :items="filterType(companies)"
                      item-value="id"
                      :item-text="(item) => `${item.code} - ${item.name}`"
                      label="Empresa:"
                      v-model="companySelected"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12">
                    <label class="text-h6">Permissões</label>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-treeview
                      v-if="companySelected !== '' || checkboxAdmin === true"
                      selectable
                      hoverable
                      return-object
                      selected-color="blue darken-4"
                      v-model="permissionsChecked"
                      multiple-active
                      dense
                      :items="permissions"
                    ></v-treeview>
                    <label
                      for="text-subtitle-1"
                      v-if="companySelected === '' && checkboxAdmin === false"
                      >Selecione uma Empresa para poder gerenciar as
                      permissões</label
                    >
                  </v-col>
                </v-row> -->
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                outlined
                @click="dialogAddCompany = false"
              >
                Fechar
              </v-btn>
              <v-btn color="success darken-1" dark @click="addCompanyToUser()">
                <v-icon left> mdi-check </v-icon>
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as UserAPI from "@/api/requests/UserRequest";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    user: {
      id: "",
      name: "",
      email: "",
      password: "",
      status: 1,
    },
    dialogAddCompany: false,
    dialogDelete: false,
    search: "",
    loading: false,
    checkboxAdmin: false,
    headers: [
      { text: "Empresa", value: "company", width: 200 },
      { text: "Tipo", value: "type", width: 100 },
      {
        text: "Ação",
        value: "actions",
        align: "right",
        sortable: false,
        width: 100,
      },
    ],
    companiesUser: [],
    companies: [],
    companySelected: "",
    typesCompany: [
      { value: "", text: "Todos" },
      { value: "for", text: "Fornecedor" },
      { value: "fra", text: "Franquia" },
      { value: "mul", text: "Multimarcas" },
    ],
    typeCompany: "",
    permissions: [],
    permissionsChecked: [],
    editedItem: {
      name: "",
      status: 1,
    },
    defaultItem: {
      id: "",
    },
    alertDialogCompany: "",
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    permissionsChecked(val) {
      console.log(val);
    },
    // checkboxAdmin(val) {
    //   if (val) {
    //     this.getPermissionsByType();
    //   }
    // },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.getCompanies();
      if (this.$route.params.id) {
        this.getUser(this.$route.params.id);
        this.getCompaniesByUser(this.$route.params.id);
      }
      // await this.getUsers();
    },
    async getUser(id) {
      // this.showLoading();
      this.loading = true;
      try {
        this.user = await UserAPI.getById(id);
        this.user.password = "*******";
      } catch (error) {
        this.user = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async getCompanies() {
      this.loading = true;
      try {
        this.companies = await CompanyAPI.getAll("?status=1");
        this.companies = this.companies.sort((a, b) =>
          a.code > b.code ? 1 : -1
        );
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "User" });
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    getColorType(type) {
      if (type == "fra") {
        return "blue darken-4";
      } else if (type === "for") {
        return "brown lingthen-1";
      } else {
        return "orange darken-3";
      }
    },
    getLabelType(type) {
      if (type == "fra") {
        return "FRANQUIA";
      } else if (type === "for") {
        return "FORNECEDOR";
      } else {
        return "MULTIMARCAS";
      }
    },
    openDialogCompany() {
      // this.getPermissionsByType();
      this.dialogAddCompany = true;
    },

    async getCompaniesByUser(id) {
      this.loading = true;
      this.companiesUser = [];
      try {
        this.companiesUser = await UserAPI.getAllCompany(id);
        this.companiesUser = this.companiesUser.sort((a, b) =>
          a.company.code > b.company.code ? 1 : -1
        );
      } catch (error) {
        console.log(error);
        this.companiesUser = [];
      } finally {
        this.loading = false;
      }
    },

    editItem(item) {
      console.log(item);
      alert("Em Implementação");
      // this.$router.push({ name: "UserEdit", params: { id: item.id } });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    userCompanies(item) {
      this.$router.push({ name: "UserCompanies", params: { id: item.id } });
    },

    async deleteItemConfirm() {
      this.deleteCompanyUser(this.editedItem.id);
      this.closeDelete();
      // alert("Em implementação");
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    filterType(companies) {
      let copyCompanies = [...companies];
      if (this.companiesUser.length > 0) {
        copyCompanies = copyCompanies.filter(
          (company) =>
            this.companiesUser.find(
              (companyUser) => companyUser.company_id === company.id
            ) === undefined
        );
      }
      if (this.typeCompany === "") {
        return copyCompanies;
      }
      let data = copyCompanies.filter(
        (company) => company.type === this.typeCompany
      );
      return data;
    },
    async getPermissionsByType() {
      let type = "";
      if (this.checkboxAdmin) {
        type = "admin";
      } else {
        type = "franchise";
      }

      try {
        let res = await fetch(`${URL}navigation/module?type=${type}`);
        let response = await res.json();
        // console.log(response);
        this.permissions = response.map((item) => ({
          id: item.id,
          name: item.name,
          children: item.routes.map((route) => ({
            id: route.id,
            name: route.name,
          })),
        }));
        // this.permissions = JSON.parse(JSON.stringify(this.permissions));
        // console.log(JSON.stringify(this.permissions));
        // this.permissionsChecked = [...this.permissions];
        // return this.permissions;
      } catch (error) {
        console.log(error);
      }
    },
    handleTypeCompany() {
      this.companySelected = "";
    },
    async addCompanyToUser() {
      if (this.companySelected === "") {
        this.alertDialogCompany = "Selecione uma empresa para poder salvar";
        return;
      }

      let data = {
        company_id: this.companySelected,
        permissions: this.permissions,
      };
      this.loading = true;
      try {
        await UserAPI.postCompany(this.user.id, data);
        this.dialogAddCompany = false;
        this.companySelected = "";
        this.getCompaniesByUser(this.user.id);
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteCompanyUser(id) {
      this.loading = true;
      try {
        await UserAPI.destroyCompany(this.user.id, id);
        this.getCompaniesByUser(this.user.id);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // handleClickAdmin() {
    //   this.getPermissionsByType();
    // },
  },
};
</script>
